import jsPDF from "jspdf";

import "jspdf-autotable";
import moment from "moment";
import { ExportPdfColor } from "../../../../../root/theme/exportColor";
import eatprestoLogo from "../../../../../assets/images/logos/logo.png";
import _ from "lodash";

function isDarkColor(color: string): boolean {
  let r = 0,
    g = 0,
    b = 0;

  if (color.startsWith("rgb")) {
    const match = color.match(/rgb\(\s*(\d+),\s*(\d+),\s*(\d+)\s*\)/);
    if (match) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
    } else {
      return false;
    }
  } else if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else {
      return false;
    }
  } else {
    return false;
  }

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance < 128;
}

const getColor = (value: number, list: any) => {
  const startColor = { r: 222, g: 255, b: 235 }; // #DEFFEB
  const endColor = { r: 2, g: 105, b: 87 }; // #026957
  const index = list.indexOf(value);

  const maxIndex = list.length - 1;
  const ratio = maxIndex === 0 ? 0 : index / maxIndex;
  const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
  const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
  const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);


  const color = value === 0 ? "#444850" : `rgb(${r}, ${g}, ${b})`; // Make it gradually more green

  return color;
};

const rgbToHex = (r: number, g: number, b: number): string => {
  const clamp = (v: number) => Math.max(0, Math.min(255, v));
  const toHex = (v: number) => clamp(v).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const parseRGB = (input: any) => {
  const regex = /rgb\(\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*(-?\d+)\s*\)/i;
  const match = input.match(regex);

  if (match) {
    const [, r, g, b] = match;
    return {
      r: Number(r),
      g: Number(g),
      b: Number(b),
    };
  } else {
    throw new Error("Invalid RGB format");
  }
};

const extractValue = (input: any) => {
  // return 10
  return input === "-" ? 0 : parseFloat(input.toString().split(" ")[0]);
};

/* Create a pdf file */
export const handleDownloadPdf = (
  columns: any,
  nodes: any,
  filterDetails: any,
  value: any,
  selected: any,
  valueTotal: any,
) => {
  const doc: any = new jsPDF("p");
  const totalPagesExp = "{total_pages_count_string}";
  const locationFilter = filterDetails.split("*")[0];
  const pageWidth = doc.internal.pageSize.getWidth();
  const today = moment().format("MMM_Do_YY").toString();
  let locationLength = 0;

  if (!locationFilter.includes(",")) {
    locationLength = 10;
  }

  /* If there is a image, insert it into the img variable. */
  const img = new Image();
  img.src = eatprestoLogo;

  const commonTableOptions = {
    styles: {
      align: "center",
      fontSize: 8,
      valign: "middle",
      halign: "center",
      borderRadius: "10px",
    },
    headStyles: {
      fillColor: [ExportPdfColor.HeaderRowColorLight],
      textColor: ["#000000"],
      fontSize: 7,
      valign: "middle",
      halign: "center",
      fontStyle: "bold",
    },
    columnStyles: {
      0: { halign: "left" },
    },
    alternateRowStyles: {
      fillColor: [ExportPdfColor.OddRowColorLight],
      textColor: ["#000000"],
    },
    tableLineWidth: 0.1,
    didDrawPage: function (data: any) {
      let pageNumber = "Page " + doc.internal.getNumberOfPages();
      // Change topic font size
      doc.setFontSize(12);
      doc.text("Presto Express Solutions", data.settings.margin.left, 12);
      // Modify the marginLeft according to the scape.
      doc.text("Hourly Sales Report", data.settings.margin.left + 144, 12);

      // Change main title font size
      doc.setFontSize(16);
      // Insert a topic for the first page only.
      if (doc.internal.getNumberOfPages() === 1) {
        /* Change the title according to the number of locations.
        If the location size is increased, show presto express. if the location size is the one, show that location. */
        doc.setTextColor("#32363E");
        if (locationFilter.includes(",")) {
        } else {
          doc.text(
            filterDetails
              .split("*")[0]
              .replace("Discount summary report for location/s:", ""),
            pageWidth / 2,
            36,
            {
              align: "center",
            },
          );
        }

        doc.setTextColor(0, 0, 0);
        doc.text(
          "Hourly Sales Report",
          pageWidth / 2,
          36 + locationLength,
          "center",
        );
        doc.setFontSize(10);

        /* Change the sub title according to the number of locations.
        If the location size is increased, show number of locations. if the location size is the one, show that location. */
        let filterLocationsDetails = "";
        if (locationFilter.split(",").length === 1) {
          filterLocationsDetails =
            "Hourly Sales Report for " + locationFilter.split(",")[0];
        } else {
          filterLocationsDetails =
            "Hourly Sales Report for " +
            locationFilter.split(",").length +
            " Locations";
        }

        doc.text(
          doc.splitTextToSize(filterLocationsDetails, 210 - 15 - 15),
          pageWidth / 2,
          44 + locationLength,
          {
            align: "center",
          },
        );

        /* Set the start date and end date */
        doc.text(
          doc.splitTextToSize(
            "Generated for the period of " + filterDetails.split("*")[1],
            210 - 15 - 15,
          ),
          pageWidth / 2,
          50 + locationLength,
          {
            align: "center",
          },
        );
      }

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        pageNumber = pageNumber + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      /* Set page number */
      let pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      doc.text(pageNumber, data.settings.margin.left, pageHeight - 10);
      doc.addImage(
        img,
        "JPEG",
        data.settings.margin.left + 144,
        pageHeight - 24,
        40,
        16,
      );
    },
    didParseCell: function (data: any, index: any) {
      if (data.column.dataKey === 0) {
        data.cell.styles.halign = "left";
      } else if (data.column.dataKey === columns.length) {
        data.cell.styles.halign = "right";
      } else {
        data.cell.styles.halign = "center";
      }

      if (data.row.index !== 0) {
        if (data.row.index % 2 === 0) {
          data.cell.styles.fillColor = [ExportPdfColor.OddRowColorLight];
          data.cell.styles.textColor = ["#000000"];
        } else {
          data.cell.styles.fillColor = [ExportPdfColor.EvenRowColorLight];
          data.cell.styles.textColor = ["#000000"];
        }
      }
      if (data.column.index !== 0 && data.section === "body") {
        // Extract the numbers using regex
        const matches: any = getColor(
          extractValue(data.cell.raw),
          selected === "total" ? valueTotal : value,
        );
        if (matches.slice(0, 3).toLowerCase() === "rgb") {
          // Convert them to numbers (optional)

          const { r, g, b } = parseRGB(matches);
          data.cell.styles.fillColor = rgbToHex(r, g, b);
          data.cell.styles.textColor = isDarkColor(matches)
            ? ["#FFFFFF"]
            : ["#000000"];
        } else {
          if (data.row.index !== 0) {
            if (data.row.index % 2 === 0) {
              data.cell.styles.fillColor = [ExportPdfColor.OddRowColorLight];
              data.cell.styles.textColor = ["#000000"];
            } else {
              data.cell.styles.fillColor = [ExportPdfColor.EvenRowColorLight];
              data.cell.styles.textColor = ["#000000"];
            }
          }
        }
      }
    },
    margin: {
      top: 30,
      bottom: 30,
    },
  };

  const tableColumn = ["Hour", ...columns];
  const tableRows: any[] = [];
  nodes.forEach((row: any) => {
    const rowData = [row.hour];
    row.data.forEach((cell: any) => {
      if (selected === "all") {
        rowData.push(
          `${cell.count} (${
            cell.value === 0 ? "-" : parseFloat(cell.value).toFixed(2)
          })`,
        );
      } else if (selected === "count") {
        rowData.push(cell.count);
      } else {
        rowData.push(
          cell.value === 0 ? "-" : parseFloat(cell.value).toFixed(2),
        );
      }
    });
    tableRows.push(rowData);
  });
  /* Create the first table */
  if (!_.isEmpty(nodes)) {
    /* Add title for the first table */
    doc.setFontSize(16);
    doc.text("Hourly Sales Report", 82, 70);

    doc.autoTable({
      ...commonTableOptions,
      columns: tableColumn,
      body: tableRows,
      startY: 65 + locationLength,
    });
  }

  if (typeof doc.putTotalPages === "function") {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save(
    `Hourly_Sales_Report_${today}_${Math.floor(
      100000 + Math.random() * 900000,
    )}.pdf`,
  );
};
